import { FORTA_WHITE } from '../../../utils/colors';

export const narrativeTextareaStyle = (isSupervisionCompleted: boolean) => ({
  backgroundColor: isSupervisionCompleted ? 'transparent' : FORTA_WHITE,
  '& .MuiInputBase-root': {
    paddingLeft: isSupervisionCompleted ? 0 : '0.5em',
  },
});
